import React, { useState, useRef } from "react";
import Select from "react-select";
import { FaTrash } from "react-icons/fa";
import { CSVOperationsManager } from "./CSVOperationsHandler";

function CustomTable({ navigationIndex }) {
  const [ rows, setRows ] = useState([]);
  const csvManagerRef = useRef();
  const [ dropdownOptions, setDropdownOptions ] = useState();

  React.useEffect(() => {
    setDropdownOptions([
      { value: "", label: "-- Select an option --", isDisabled: true },
    ]);
  }, []);

  const addRow = () => {
    setRows([ ...rows, { message: "", option: "" } ]);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [ ...rows ];
    updatedRows[ index ][ field ] = value;
    setRows(updatedRows);
  };

  function triggerFilePickup(file, json_attributes) {
    const formattedOptions = Object.keys(json_attributes).map((key) => ({
      value: key,
      label: json_attributes[ key ],
    }));

    setDropdownOptions((prev) => [
      ...prev.filter((opt) => opt.isDisabled),
      ...formattedOptions,
    ]);
  }

  const deleteRow = (indexToDelete) => {
    const updatedRows = rows.filter((_, i) => i !== indexToDelete);
    setRows(updatedRows);
  };

  function getCustomMessageArray() {
    const result = [];

    rows.forEach((row) => {
      const index = parseInt(row.option);
      const optionObj = dropdownOptions?.[ index + 1 ];
      const label = optionObj?.label || "Unknown";
      result.push([ label, [ row.message ] ]);
    });

    return result;
  }

  function convertToBackendFormat(instructionsPool) {
    let fixedFormat = [];
    for (let key of Object.keys(instructionsPool)) {
      fixedFormat.push([ key, instructionsPool[ key ] ]);
    }
    return fixedFormat;
  }

  return (
    <div
      style={{
        padding: "32px",
        backgroundColor: "#fff5e0",
        borderRadius: "16px",
        border: "1px solid #e6d5b8",
        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
        width: "100%",
        maxWidth: "1500px",
        margin: "0 auto",
      }}
    >
      {/* HEADER */}
      <div style={{ marginBottom: "20px" }}>
        <h2
          style={{
            color: "#060606",
            fontSize: "20px",
            background: "#ffcb77",
            fontWeight: 600,
            marginBottom: "4px",
          }}
        >
          CSV Message Mapping
        </h2>

        <p style={{ color: "#888", fontSize: "13px" }}>
          Upload a CSV file and map messages to specific columns.
        </p>
      </div>

      {/* CSV MANAGER */}
      <div style={{ marginBottom: "22px" }}>
        <CSVOperationsManager
          ref={csvManagerRef}
          navigationIndex={navigationIndex}
          key={navigationIndex}
          options={{
            onFilePickup: triggerFilePickup,
            modifyJson: getCustomMessageArray,
          }}
        />
      </div>

      {/* TABLE */}
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0 14px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                textAlign: "left",
                color: "#aaa",
                fontSize: "13px",
                fontWeight: 500,
                paddingLeft: "6px",
              }}
            >
              Message
            </th>

            <th
              style={{
                textAlign: "left",
                color: "#aaa",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              Column
            </th>

            <th></th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              {/* MESSAGE */}
              <td style={{ paddingRight: "10px" }}>
                <input
                  type="text"
                  value={row.message}
                  placeholder="Enter message..."
                  onChange={(e) =>
                    handleInputChange(index, "message", e.target.value)
                  }
                  style={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "8px",
                    border: "1px solid #444",
                    padding: "0 12px",
                    fontSize: "14px",
                    background: "#ffffff",
                    color: "#000000",
                    outline: "none",
                  }}
                />
              </td>

              {/* SELECT */}
              <td style={{ width: "40%" }}>
                <Select
                  options={dropdownOptions}
                  defaultValue={dropdownOptions?.[ 0 ]}
                  onChange={(selectedOption) =>
                    handleInputChange(index, "option", selectedOption.value)
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "8px",
                      minHeight: "40px",
                      border: "1px solid #444",
                      background: "#ffffff",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "#000000",
                    }),
                    menu: (base) => ({
                      ...base,
                      background: "#1f1f1f",
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isFocused ? "#333" : "#1f1f1f",
                      color: "#fff",
                    }),
                  }}
                />
              </td>

              {/* DELETE */}
              <td style={{ width: "40px", textAlign: "center" }}>
                <FaTrash
                  onClick={() => deleteRow(index)}
                  style={{
                    color: "#ff5b5b",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                  title="Delete row"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ADD BUTTON */}
      <div style={{ marginTop: "16px", textAlign: "center" }}>
        <button
          onClick={addRow}
          style={{
            borderRadius: "8px",
            padding: "8px 18px",
            fontSize: "14px",
            fontWeight: 500,
            background: "#ffcb77",
            border: "none",
            color: "#2b2b2b",
            cursor: "pointer",
          }}
        >
          + Add Row
        </button>
      </div>
    </div>
  );
}

export default CustomTable;